import { IRaffleResultScheduleBadgeDTO } from "@hooks/dtos/raffles/IRaffleResultScheduleDTO";
import {
  RaffleResultScheduleStatusEnum,
  RaffleResultScheduleStatusTypes,
  RaffleResultScheduleTypeEnum,
  RaffleResultScheduleTypeTypes,
} from "@hooks/enums/raffle_result_schedule";

export const raffleResultScheduleTypes: IRaffleResultScheduleBadgeDTO[] = [
  {
    value: RaffleResultScheduleTypeEnum.LOTTERY,
    text: "Loteria Federal",
    title: "Resultado definido pela Loteria Federal.",
    color: "primary",
  },
  {
    value: RaffleResultScheduleTypeEnum.RANDOM,
    text: "Sorteio interno",
    title: "Resultado definido por sorteio interno aleatório.",
    color: "info",
  },
];

export const raffleResultScheduleStatusTypes: IRaffleResultScheduleBadgeDTO[] =
  [
    {
      value: RaffleResultScheduleStatusEnum.WAITING,
      text: "Aguardando",
      title: "O sorteio está agendado e aguardando processamento.",
      color: "warning",
    },
    {
      value: RaffleResultScheduleStatusEnum.PROCESSING,
      text: "Processando",
      title: "O resultado está em processamento.",
      color: "info",
    },
    {
      value: RaffleResultScheduleStatusEnum.DONE,
      text: "Resultado definido",
      title: "O resultado da campanha já foi definido.",
      color: "success",
    },
    {
      value: RaffleResultScheduleStatusEnum.FAIL,
      text: "Falhou",
      title: "O processamento do sorteio falhou.",
      color: "danger",
    },
    {
      value: RaffleResultScheduleStatusEnum.CANCELED,
      text: "Cancelado",
      title: "O sorteio foi cancelado.",
      color: "secondary",
    },
  ];

export const getRaffleResultScheduleType = (
  type: RaffleResultScheduleTypeTypes,
): IRaffleResultScheduleBadgeDTO => {
  let ret = raffleResultScheduleTypes.find((it) => it.value === type);
  if (!ret)
    ret = { value: "", text: "Erro", title: "Erro", color: "danger" };
  return ret;
};

export const getRaffleResultScheduleStatus = (
  status: RaffleResultScheduleStatusTypes,
): IRaffleResultScheduleBadgeDTO => {
  let ret = raffleResultScheduleStatusTypes.find((it) => it.value === status);
  if (!ret)
    ret = { value: "", text: "Erro", title: "Erro", color: "danger" };
  return ret;
};
